import marvarApi from '../api/marvarApi'
import { useDispatch, useSelector } from 'react-redux'
import { clearErrorMessage } from 'store'
import { onLogout } from 'store'
import { onLogin } from 'store'
import { onChecking } from 'store'
import { usePermission } from 'react-permission-role'
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import { useState } from 'react'

const useAuthStore = () => {
    const { setUser } = usePermission()
    const { status, user, errorMessage } = useSelector(state => state.auth)
    const [ loadingLogin, setLoadingLogin ] = useState(false)
    const dispatch = useDispatch()

    const startLogin = async({ email, password }) => {
        dispatch( onChecking() )

        try {
            setLoadingLogin(true)
            const { data } = await marvarApi.post('/login/verify', { email, password })
            // console.log('[useAuthStore][startLogin] data ', data)
            const { data:dataLogin } = data
            localStorage.setItem('token', dataLogin.token)
            localStorage.setItem('username', dataLogin.username)
            localStorage.setItem('token-init-date', new Date().getTime())
            setUser({
                id: dataLogin.id,
                permissions: dataLogin.permissions
            })
            dispatch( onLogin({ name: dataLogin.name, uid: dataLogin.id, username: dataLogin.username }) )

            toast.success(`Bienvenido ${dataLogin.name}`, {
                position: "top-right",
                theme: "colored"
            })

            setLoadingLogin(false)
        } catch (e) {
            // console.log('[useAuthStore][startLogin] exception ', e)
            setLoadingLogin(false)
            Swal.fire({
                title: "ERROR!",
                text: e.response.data.data?.msg || '---',
                icon: "error"
            });
            dispatch( onLogout( e.response.data.data?.msg || '---') )
            setTimeout(() => {
                dispatch(clearErrorMessage())
            }, 10)
        }
    }

    const startRegister = async({ username, firstname, lastname, email, password }) => {
        dispatch(onChecking())
        try {
            const { data } = await marvarApi.post('/login/register', { username, firstname, lastname, email, password })
            localStorage.setItem('token', data.token)
            localStorage.setItem('token-init-date', new Date().getTime())
            dispatch( onLogin({ name: data.name, uid: data.id, username: user.username }) )
        } catch (e) {
            dispatch( onLogout(e.response.data?.msg || '--') )
            setTimeout(() => {
                dispatch(clearErrorMessage())
            }, 10)
        }
    }

    const checkAuthToken = async() => {
        const token = localStorage.getItem('token')
        const username = localStorage.getItem('username')

        if (!token) return dispatch(onLogout())

        dispatch(onChecking())
        try {
            const params = new URLSearchParams()
            params.append('username', user.username)
            const { data } = await marvarApi.get('/login/renew', params)
            const { data:dataRenew } = data
            localStorage.setItem('token', dataRenew.token)
            localStorage.setItem('token-init-date', new Date().getTime())
            dispatch( onLogin({ name: dataRenew.name, uid: dataRenew.id, username }) )
        } catch (e){
            localStorage.clear()
            if (e.response?.status === 401) {
                Swal.fire({
                    title: "Sesión expirada",
                    text: 'Tu sesión ha finalizado, por favor ingresa nuevamente',
                    icon: "warning"
                });
            }
            dispatch(onLogout())
            setTimeout(() => {
                dispatch(clearErrorMessage())
            }, 10)
        }

    }

    const startLogout = () => {
        localStorage.clear()
        dispatch(onLogout())
    }

    return {
        loadingLogin,
        status,
        user,
        errorMessage,
        startLogin,
        startRegister,
        checkAuthToken,
        startLogout
    }
}

export {
    useAuthStore
}